import React from 'react';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

import type { QueueWorker } from '~/components/communications/PhoneCall/types';
import Tooltip from '~/components/core/Atomic/Tooltip';

const QueueAvailabilityIndicator = ({ queuesWorker }: { queuesWorker: QueueWorker[] }) => {
  let color: string;
  let title: string;
  if (queuesWorker.length === 0) {
    color = 'text-slate-700';
    title = 'No adjusters assigned to queue';
  } else if (queuesWorker.filter((worker) => worker.is_available).length > 0) {
    color = 'text-green-700';
    title = 'Available';
  } else {
    color = 'text-red-700';
    title = 'Busy';
  }

  return (
    <Tooltip title={title} placement="left">
      <FiberManualRecordIcon className={color} />
    </Tooltip>
  );
};

export default QueueAvailabilityIndicator;
